export enum MazeedEnumsStoreSummaryEnum {
  inReview = 'inReview',
  blocked = 'blocked',
  rejected = 'rejected',
  active = 'active',
  disabled = 'disabled',
  draft = 'draft',
}
